import getUserConfirmation from "./getUserConfirmation";

export default getUserConfirmation;
